import ACCESSORIES from "../constants/Accessories";

export const OrderItemsTypes = {
  BUNDLE_PACKAGE: 'bundle_package',
  STB: 'stb',
  CORDLESS_PHONE: 'cordless_phone',
  MSISDN: 'msisdn',
  INSTALLATION_COST: 'installation_cost',
  SIM_ACTIVATION: 'sim_activation',
  TARIFF_PACKAGE: 'tariff_package',
  PHONE: "phone",
  COSMOS_PARTICIPATION: 'cosmos_participation',
  MIN_PARTICIPATION: 'min_participation',
  SUBSCRIPTIONS_IN_ADVANCE: 'subscriptions_in_advance',
  INSURANCE: 'insurance',
  PARTICIPATION: 'participation',
  TV: 'tv',
  DELIVERY_COST: 'delivery_cost',
  ...ACCESSORIES,
} as const;

type OrderItemsKeys = keyof typeof OrderItemsTypes;
export type OrderItemsType = typeof OrderItemsTypes[OrderItemsKeys];
